"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _productCard = _interopRequireDefault(require("@cimpress-technology/product-card"));

var _core = require("@emotion/core");

var _useSku2 = _interopRequireDefault(require("./hooks/useSku"));

/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
var _StyledProductCard = (0, _styledComponents["default"])(_productCard["default"]).withConfig({
  displayName: "SkuProductCard___StyledProductCard",
  componentId: "sc-1r6shyo-0"
})(["width:100% !important;.overlay{display:none !important;}"]);

var SkuProductCard = function SkuProductCard(_ref) {
  var sku = _ref.sku,
      getAccessToken = _ref.getAccessToken,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["sku", "getAccessToken"]);

  var _useSku = (0, _useSku2["default"])(sku, getAccessToken),
      data = _useSku.data,
      isLoading = _useSku.isLoading;

  var _ref2 = data || {},
      mcpSku = _ref2.mcpSku,
      scene = _ref2.scene,
      name = _ref2.name,
      description = _ref2.description,
      externalFulfillerId = _ref2.externalFulfillerId;

  var productDetails = [{
    key: 'Description',
    value: description
  }];
  return (0, _core.jsx)(_StyledProductCard, (0, _extends2["default"])({
    allowImageClick: true,
    imageUrl: scene,
    loading: isLoading,
    notSelectable: true,
    orientation: "horizontal",
    productDetails: productDetails,
    productFulfiller: externalFulfillerId,
    productName: name,
    size: "s",
    uniqueId: mcpSku
  }, rest));
};

var _default = SkuProductCard;
exports["default"] = _default;